import { Form } from "react-final-form";
import {
  onSubmit,
  onValidate,
} from "../RentContractSettledAgreementsForm/RentContractSettledAgreementsSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import RentContractSettledAgreementsFormStepOne from "./RentContractSettledAgreementsFormSteps/RentContractSettledAgreementsFormStepOne";

import { useEffect, useState } from "react";

const RentContractForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
      });
      return;
    }
    setInitialValues({
      ..._initialValues,
    });
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="RentContractForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <RentContractSettledAgreementsFormStepOne
                {...formProps}
                {...props}
              />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default RentContractForm;
